import { useEffect, useRef } from 'react'
import { useDispatch } from '@wordpress/data'
import { store_name } from '../../../../store/frontend'
import { Form } from '../../../components/Form/Form'
import { useBookingContext } from '../../../providers/BookingFormProvider/BookingFormProvider'
import './Steps.scss'
import { IOption } from '../../../components/Form/types'

export const CheckoutStep = () => {
    const { fields, formData } = useBookingContext()
    const { fetchBookingAmounts } = useDispatch(store_name)
    const prevFieldValues = useRef<{ [slug: string]: any }>({})

    useEffect(() => {
        if (!fields || fields.length === 0) return
        const excluded = [
            'first_name',
            'last_name',
            'phone',
            'email',
            'description',
        ]

        // Find if any relevant field has changed
        const changed = fields.find(
            (field) =>
                !excluded.includes(field.slug) &&
                prevFieldValues.current[field.slug] !== field.value
        )

        // Always update prevFieldValues before fetchBookingAmounts
        fields.forEach((field) => {
            prevFieldValues.current[field.slug] = field.value
        })

        if (changed) {
            // For extra fields, we need to reconstruct the 'extra' property in formData
            let updatedFormData = { ...formData }

            // Check if the changed field is an "extra" field (not in excluded/default fields)
            if (!excluded.includes(changed.slug)) {
                // Reconstruct the 'extra' field using the same logic as constructFormData
                // Find all extra fields
                const extraFields = fields.filter(
                    (field) =>
                        !excluded.includes(field.slug) && field.type !== 'file'
                )

                // Rebuild the extra array as in constructFormData
                const extraArray = extraFields.map((field) => {
                    // Use the same logic as wbkCreateExtraFieldValue
                    let value = field.value
                    if (
                        field.type === 'dropdown' &&
                        Array.isArray(field.value)
                    ) {
                        value = field.value
                            .map((item: any) => item.value)
                            .join(',')
                    } else if (
                        field.type === 'dropdown' &&
                        !Array.isArray(field.value)
                    ) {
                        value = (field.value as IOption)?.value
                    }
                    return [field.slug, field.placeholder || '', value]
                })

                updatedFormData = {
                    ...updatedFormData,
                    extra: JSON.stringify(extraArray),
                }
            }

            fetchBookingAmounts(updatedFormData)
        }
    }, [fields, formData, fetchBookingAmounts])

    return (
        <div className={'wbk_step__native-scroll-wrapper'}>
            <div className={'wbk_step__form-wrapper'}>
                <Form />
            </div>
        </div>
    )
}
